import { StatusBar } from '@capacitor/status-bar';
import { isIos, isWeb, isWindows } from '../../shared/utils/is';

const SECONDARY_MAIN_COLOR = '#132d74';

export const setStatusBarColor = async (colorHex: string = SECONDARY_MAIN_COLOR) => {
    if (isWeb() || isWindows()) {
        return;
    }

    if (isIos()) {
        window.$('.fullscreen_filler').css('background-color', colorHex);
        return;
    }

    StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {});
    StatusBar.setBackgroundColor({ color: colorHex }).catch(() => {});
};
